import React from "react";
import PropTypes from "prop-types";
import { Button } from "@domestika-dev/prudencio/dist/atoms/Buttons";
import { IconForm } from "@domestika-dev/prudencio/dist/atoms/Icon";
import { ArrowLeft, Close } from "@domestika-dev/prudencio/dist/atoms/Icons";
import { Box, Flex } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { DomestikaLiveLogo } from "@domestika-dev/prudencio/dist/atoms/DomestikaLiveLogo/DomestikaLiveLogo";

export const LiveSetupHeader = ({ showPreviousStep, onPreviousStep, onClose }) => {
  return (
    <Flex
      position="absolute"
      top={0}
      left={0}
      width="100%"
      justifyContent="space-between"
      backgroundColor="coco"
      style={{ zIndex: 9999 }}
    >
      {showPreviousStep && (
        <Button
          buttonType="text"
          size="medium"
          action={onPreviousStep}
          style={{ position: "absolute", top: "16px", left: "16px" }}
        >
          <IconForm size={["small", "small", "medium"]} color="sonar">
            <ArrowLeft />
          </IconForm>
        </Button>
      )}
      <Box margin="auto" paddingTop={["20px", "40px", "40px"]}>
        <DomestikaLiveLogo width={["176px", "190px", "190px"]} heigth={["26px", "28px", "28px"]} />
      </Box>
      <Button
        buttonType="text"
        size="medium"
        action={onClose}
        style={{ position: "absolute", top: "16px", right: "16px" }}
      >
        <IconForm size={["small", "small", "small"]} color="sonar">
          <Close />
        </IconForm>
      </Button>
    </Flex>
  );
};

LiveSetupHeader.propTypes = {
  showPreviousStep: PropTypes.bool,
  onPreviousStep: PropTypes.func,
  onClose: PropTypes.func.isRequired,
};

LiveSetupHeader.defaultProps = {
  showPreviousStep: false,
  onPreviousStep: () => {},
};

export default LiveSetupHeader;
